var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormGroup, Validators, FormControl } from "@angular/forms";
var HarvestReportFormGroup = /** @class */ (function (_super) {
    __extends(HarvestReportFormGroup, _super);
    function HarvestReportFormGroup() {
        var _this = this;
        var controlSet = {
            startDate: new FormControl(null, Validators.required),
            endDate: new FormControl(null, Validators.required),
            crop: new FormControl()
        };
        _this = _super.call(this, controlSet) || this;
        _this._startDate = controlSet.startDate;
        _this._endDate = controlSet.endDate;
        _this._crop = controlSet.crop;
        return _this;
    }
    Object.defineProperty(HarvestReportFormGroup.prototype, "startDateFormControl", {
        get: function () {
            return this._startDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestReportFormGroup.prototype, "endDateFormControl", {
        get: function () {
            return this._endDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestReportFormGroup.prototype, "cropFormControl", {
        get: function () {
            return this._crop;
        },
        enumerable: true,
        configurable: true
    });
    return HarvestReportFormGroup;
}(FormGroup));
export { HarvestReportFormGroup };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/harvest-report-form/harvest-report-form-group.ts.pre-build-optimizer.js